<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">Edit Allowed IP</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()">
         <mat-icon>close</mat-icon>
      </button>
   </div>

   <form [formGroup]="form" (ngSubmit)="onCreate()">
      <mat-dialog-content class="bottom-extra-gap">
         <mat-form-field>
            <mat-label>Account</mat-label>
            <input
               autocomplete="off"
               type="text"
               [lcsSingleSelect]="accountSel"
               ndtAccountSelect
               formControlName="accountId"
            />
            <ndt-account-select #accountSel></ndt-account-select>
         </mat-form-field>
         <mat-form-field class="flex-full">
            <mat-label>QManage Ticket</mat-label>
            <input matInput autocomplete="off" type="text" formControlName="qManageTicketId" id="qManageTicketId" />

            @if (form.get('qManageTicketId')?.hasError('maxlength')) {
            <mat-error> Ticket cannot be more than 255 characters long. </mat-error>
            }
         </mat-form-field>
      </mat-dialog-content>

      <mat-dialog-actions>
         <button type="submit" title="Save" mat-raised-button> Save </button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
